<template>
  <div
    v-if="loading"
    class="Squares gap-4 sm:px-4 Squares--LastOpened Squares--Placeholders"
  >
    <file-grid-item-loading v-for="i in 10" :key="i" />
  </div>
  <div v-else class="Squares gap-4 lg:gap-6 sm:px-4">
    <template v-for="(item, key) in items" :key="item.url">
      <file-grid-item :item="item" :rank="key" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    items() {
      return this.list
    }
  },
  methods: {}
}
</script>
